import {getGoogleTrips} from "../../modules"
import initialState from "./initialState"

// SELECTORS
export const getJurisdictions = (state) => getGoogleTrips(state).jurisdictions

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
